/**
 * YouTube カードのその場再生。
 *
 * 記事を開いた時点では**何も読み込まない**。上流が描いたカード (自前配信の
 * サムネイル) のままなので、読者の情報が Google へ渡らず、ページも軽い。
 * 再生ボタンが押されたときだけ埋め込みプレーヤーに差し替える。
 *
 * `youtube-nocookie.com` を使うのは、再生するまで Cookie を置かせないため。
 * CSP の `frame-src` もこのホストだけを許している。
 */
const EMBED_ORIGIN = 'https://www.youtube-nocookie.com';

export function activateYouTubeEmbeds(root: ParentNode): void {
  root.querySelectorAll<HTMLAnchorElement>('a.blog-embed--youtube[data-youtube-id]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      // 新しいタブで開きたい人の操作は奪わない
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (event.button !== 0) return;
      const videoId = anchor.dataset['youtubeId'];
      if (!videoId) return;

      event.preventDefault();
      anchor.replaceWith(playerFor(videoId, anchor.querySelector('.blog-embed__title')?.textContent ?? '動画'));
    });
  });
}

function playerFor(videoId: string, title: string): HTMLElement {
  const frame = document.createElement('div');
  frame.className = 'blog-embed blog-embed--player';

  const iframe = document.createElement('iframe');
  // 値は上流が検証した動画 ID だが、URL 組み立て時にもエンコードする
  iframe.src = `${EMBED_ORIGIN}/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
  iframe.title = title;
  iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  iframe.allowFullscreen = true;
  iframe.loading = 'lazy';
  iframe.referrerPolicy = 'strict-origin-when-cross-origin';

  frame.append(iframe);
  return frame;
}
